import { atomFamily } from "recoil"
import { CrossSellingData } from "./models"

export const crossSellingListId = "recommended-articles"

export function getCrossSellingDefaultState(): CrossSellingData {
    return {
        referenceArticle: undefined,
        // general for crossSelling loadArticles & loadNextArticles!
        isLoading: false,
        preventReset: false,

        // The state of the button in the CustomerAlsoBoughtArticleChain component.
        displayCustomerAlsoBoughtButton: false,

        // Chain states
        chains: {
            alsoBoughtArticles: [],
            alsoBoughtProductGroups: [],
            recommendedProductGroups: [],
        },
        // Last response of  CrossSelling's GetRecommendedArticles call
        data: {
            alsoBoughtArticles: [],
            alsoBoughtProductGroups: [],
            recommendedProductGroups: [],
        },
    }
}

export const CrossSellingCombinedStates = atomFamily<CrossSellingData, string | undefined>({
    key: "crossSellingCombinedStates",
    default: () => getCrossSellingDefaultState(),
})
